import mapActions from './mapActions';

export default mapActions('tool_states', {
    fetchAll_url: () => '/api/tools/states'
});